<template>
  <a :href="saleBannerArray.link_url"
      class="saleBanner__link"
      :target="saleBannerArray.blank === 1 ? '_blank': ''"
      v-if="nullHidden"
  >
    <img class="saleBanner__img" :src="saleBannerArray.image_url">
  </a>
</template>

<script>
export default {
  name: 'sale-banner',
  props: {
    saleBannerArray: {
      type: Object,
      default () { return {} }
    }
  },
  computed: {
    nullHidden() {
      if (this.saleBannerArray.link_url === '' || this.saleBannerArray.image_url === '') {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
  .saleBanner {
    width: 100vw;
    &__link {
      width: 100vw;
    }

    &__img {
      width: 100%;
      max-width: 100%;
      height: auto;
      padding: 12px;
      background: #f3f3f3;
    }
  }

</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SaleBanner.vue